import { Link } from "react-router-dom";
import { Linkedin, Phone, Mail, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container-narrow section-padding pb-10 pt-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <h3 className="font-display text-lg font-extrabold tracking-tight">
              ELEVATE <span className="text-secondary">GLOBAL</span>{" "}
              <span className="block text-sm font-semibold tracking-wide text-primary-foreground/80">
                Solutions
              </span>
            </h3>
            <div className="mt-3 h-px w-16 bg-secondary/80" />
            <p className="mt-4 text-sm text-primary-foreground/70">
              Trained acquisition teams for US real estate investors. Cold calling, appointment setting,
              and CRM follow-up that fills your pipeline.
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="https://www.linkedin.com/company/elevate-global-solutions-egypt/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-primary-foreground/80 transition-colors hover:border-secondary hover:text-secondary"
              >
                <Linkedin size={16} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold uppercase tracking-wider text-secondary">Company</h4>
            <nav className="flex flex-col gap-2 text-sm">
              {[
                { label: "Services", to: "/services" },
                { label: "About", to: "/about" },
                { label: "Blog", to: "/blog" },
                { label: "Contact", to: "/contact" },
                { label: "Book a Call", to: "/book" },
              ].map((link) => (
                <Link key={link.to} to={link.to} className="text-primary-foreground/70 transition-colors hover:text-secondary">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold uppercase tracking-wider text-secondary">What We Do</h4>
            <nav className="flex flex-col gap-2 text-sm">
              {[
                { label: "Real Estate Cold Calling", to: "/services/real-estate-cold-calling" },
                { label: "Appointment Setting", to: "/services/appointment-setting" },
                { label: "Acquisition Managers", to: "/services/acquisition-managers" },
                { label: "Real Estate VAs", to: "/services/real-estate-virtual-assistants" },
                { label: "CRM Follow-Up", to: "/services/investor-follow-up" },
              ].map((link, i) => (
                <Link key={i} to={link.to} className="text-primary-foreground/70 transition-colors hover:text-secondary">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold uppercase tracking-wider text-secondary">Contact</h4>
            <a
              href="tel:+12142962124"
              className="inline-flex items-center gap-2.5 rounded-lg border border-white/15 bg-white/[0.06] px-3.5 py-2.5 text-base font-bold text-primary-foreground transition-colors hover:border-secondary hover:bg-white/[0.10] hover:text-secondary"
            >
              <Phone size={18} className="text-secondary" /> (214) 296-2124
            </a>
            <a href="mailto:abdelrahaman@elevateglobalsolutions.net" className="mt-3 flex items-center gap-2 text-sm text-primary-foreground/80 transition-colors hover:text-secondary">
              <Mail size={14} className="text-secondary" /> abdelrahaman@elevateglobalsolutions.net
            </a>
            <div className="mt-3 flex items-start gap-2 text-xs text-primary-foreground/60">
              <Clock size={13} className="mt-0.5 text-secondary" />
              <span>Mon, Fri · 9am, 6pm in every US time zone</span>
            </div>
            <Link
              to="/book"
              className="mt-5 inline-flex items-center justify-center rounded-md bg-secondary px-5 py-2.5 text-sm font-bold text-secondary-foreground shadow-lg shadow-secondary/20 transition-all hover:-translate-y-px hover:bg-secondary/90 hover:shadow-xl hover:shadow-secondary/30"
            >
              Book a Free Strategy Call
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-primary-foreground/50 sm:flex-row">
          <span>© 2026 Elevate Global Solutions. All rights reserved.</span>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/privacy" className="transition-colors hover:text-secondary">Privacy</Link>
            <Link to="/terms" className="transition-colors hover:text-secondary">Terms</Link>
            <Link to="/sitemap" className="transition-colors hover:text-secondary">Site Map</Link>
            <span>Serving real estate investors across all 50 states.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
